import {ChangeDetectionStrategy, Component, Optional} from '@angular/core';

import {ImageTileLargeComponent} from '../image-tile-large/image-tile-large.component';
import {ImageTileComponent} from '../image-tile/image-tile.component';

/**
 * Image Tile Sublabel Component
 *
 * This component contains the text for the top label in small font size and light weight
 * Can only be used inside a maia-image-tile
 *
 * @ngModule TilesModule
 */
@Component({
  selector: 'maia-image-tile-sublabel',
  template: '<ng-content></ng-content>',
  styleUrls: ['./image-tile-sublabel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageTileSublabelComponent {
  public constructor(
    @Optional() parent?: ImageTileComponent,
    @Optional() parentLarge?: ImageTileLargeComponent,
  ) {
    if (parent == null && parentLarge == null) {
      throw new Error(
        'Cannot create a <maia-image-tile-sublabel /> component out of <maia-image-tile /> component',
      );
    }
  }
}
